import { CAPS_LOCK_WARNING } from "constants/settings";
import { config } from "utilities/config";

export const GetMentoringTopicsListPayload = {
  properties: [
    "ctpt_topicsid",
    "ctpt_topic",
    "ctpt_description",
    "ctpt_categories"
  ],
  formattedFields: [
    "_ctpt_categories_value"
  ],
  global: true,
  filter: {
    globalfilter: "",
    globalAndOperator: false,
    fieldAndOperator: false,
    filterfields: []
  },
  recordtype: "ctpt_topicses",
  idfield: "ctpt_topicsid",
  continuationToken: "",
  pagesize: 1000
};

export const getMentoringTopicsListSchema = {
  title: "Add Topics",
  logicalname: "Contact2",
  type: "object",
  additionalDescription: "Please click the drop-down menu to select the relevant topic(s). Multiple topics may be selected.",
  properties: {
    ctpt_topicsid: {
      title: "Topics",
      type: "string",
      datatype: "array",
      enum: [],
      enumNames: [],
      isDynamic: true,
      payload: GetMentoringTopicsListPayload,
      apiURL: config.teleportal.submitForm.get,
      isMentoringTopic: true
    }
  }
};

